import loadable from '@loadable/component';

export default {
  // openclass: 公开课(之前的open|wangshou|mianshou已经无法用作判断)
  '/:type/openclass/:product_id': loadable(() => import('./ProductDetail')),
  '/:type/open/:product_id': loadable(() => import('./ProductDetail')),
  '/:type/wangshou/:product_id': loadable(() => import('./ProductDetail')),
  '/:type/mianshou/:product_id': loadable(() => import('./ProductDetail')),
  '/:type/live/:product_id': loadable(() => import('./ProductDetail')),
  '/:type/book/:product_id': loadable(() => import('./ProductDetail')),
  '/:type/recommend/:product_id': loadable(() => import('./ProductDetail')),
  '/:type/mall/order/create/:product_id': loadable(() => import('./ProductOrderCreate')),
  '/:type/newcourse': loadable(() => import('./Newcourse')),
  '/:type/mall/cartOrder/create': loadable(() => import('./ShoppingCartOrderCreate')),
  '/:type/mall/cartOrder/tobepaid/:mainTradeNo': loadable(() => import('./ShoppingCartToBePaid')),//待支付订单确认页
};
